module.exports = __webpack_public_path__ + "static/img/江苏省人民医院.c755f9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/index/assets/pc/cooperation/outer/江苏省人民医院.png
// module id = 2HUm
// module chunks = 0 1 2 9